import VariantColorComponent from "../components/common/VariantComponents/VariantColorComponent";
import VariantTextComponent from "../components/common/VariantComponents/VariantTextComponent";
import { isObjEmpty } from ".";

export const VariantsData = {
  Size: {
    id: "size",
    Component: ({ attr = [], handleSave, ...props }) => (
      <VariantTextComponent
        keyId='Size'
        attributes={attr}
        handleSave={handleSave}
        {...props}
      />
    ),
  },
  Color: {
    id: "color",
    Component: ({ attr = [], handleSave, ...props }) => (
      <VariantColorComponent
        keyId='Color'
        attributes={attr}
        handleSave={handleSave}
        {...props}
      />
    ),
  },
  Material: {
    id: "material",
    Component: ({ attr = [], handleSave, ...props }) => (
      <VariantTextComponent
        keyId='Material'
        attributes={attr}
        handleSave={handleSave}
        {...props}
      />
    ),
  },
};

export const generateVariantsData = (variantArray) => {
  const componentsMap = {
    Color: VariantColorComponent,
  };

  return variantArray.reduce((acc, variant) => {
    acc[variant] = {
      id: variant.toLowerCase(),
      Component: ({ attr = [], handleSave, ...props }) => {
        const ComponentToRender = componentsMap[variant] || VariantTextComponent;
        return (
          <ComponentToRender
            keyId={variant}
            attributes={attr}
            handleSave={handleSave}
            {...props}
          />
        );
      },
    };
    return acc;
  }, {});
};


export const ATTR_OPTION_ACTIONS = {
  INPUT: "input",
  DELETE: "delete",
};
export const mapTextValue = (attrOptions = []) => {
  return attrOptions.map((opt) => ({
    label: opt,
    value: opt,
  }));
};
export const validateColorArray = (arr = []) => {
  return arr
    .slice(0, -1)
    .every((x) => x && x?.value?.length & x?.label?.length);
};

export const filterColorArray = (arr = []) => {
  return arr.filter((x) => x && x?.value?.length & x?.label?.length);
};

export const filterOptArray = (arr = []) => arr.filter((x) => x?.value?.length);

export const mapTextOptArray = (arr = []) => arr.map((x) => ({ value: x?.value, label: "" }));

export const VariantTextPlaceholders = {
  Size: "Small, medium, etc.",
  Material: "Cotton, silk, etc.",
  Color: "Black, red, etc.",
};

export const VariantGeneral = {
  placeholder: "Size, color, material",
  label: "Select size, color, material",
};

export const getVariantName = (attrs) => {
  if (attrs) {
    const keys = Object.keys(attrs);
    return keys.map((oKey) => attrs[oKey]?.value).join(" / ");
  }
};

export const validateAttributeOptions = (attrOptions = []) => {
  const opts = attrOptions.map((opt) => opt?.value?.toLowerCase?.());
  let breakFromLoop = false;
  opts.reduce((acc, current) => {
    if (breakFromLoop) return acc;

    if (acc[current]) {
      breakFromLoop = true;
    } else {
      acc[current] = 1;
    }
    return acc;
  }, {});
  return !breakFromLoop;
};

export const displayVariantTable = [
  {
    name: "Variant",
    textAlign: "left",
    flex: "none",
    width: "25%",
  },
  {
    name: "Weight",
    flex: 1,
    textAlign: "center",
  },
  {
    name: "Price",
    flex: 1,
    textAlign: "center",
  },
  {
    name: "Min order qty",
    flex: 1,
    textAlign: "center",
  },
  {
    name: "Qty available",
    flex: 1,
    textAlign: "center",
  },
];
export const variantTableHead = [
  {
    name: "Variants",
    flex: "none",
    textAlign: "left",
    width: "25%",
  },
  {
    name: "Weight",
    flex: 1,
    textAlign: "center",
  },
  {
    name: "Price",
    flex: 1,
    textAlign: "center",
  },
  {
    name: "Min order qty",
    flex: 1,
    textAlign: "center",
  },
  {
    name: "Qty available",
    flex: 1,
    textAlign: "center",
  },
  {
    name: "",
    isDelete: true,
    flex: 0.25,
    textAlign: "center",
  },
];
export const colors = ["red", "blue", "green", "purple", "orange"];

export const handleNumerInput = (value, callBack = () => { }) => {
  if (value === "" || /^\d{1,}(\.\d{0,4})?$/.test(value)) callBack();
};

export const CREATED_VARIANT_FIELDS = {
  WEIGHT: "weight",
  ATTRIBUTES: "attributes",
  SALE_PRICE: "sale_price",
  MINIMUM_ORDER_QUANTITY: "minimum_order_quantity",
  STOCK_QUANTITY: "stock_quantity",
  IMAGES: "images",
};

export const validateVariants = (createdVariants = []) => {
  return createdVariants.filter((value) => {
    const checkAtt = !isObjEmpty(value?.[CREATED_VARIANT_FIELDS.ATTRIBUTES]);
    const isQtyTypeNumber =
      typeof value?.[CREATED_VARIANT_FIELDS.STOCK_QUANTITY] === typeof 1;
    return (
      checkAtt &&
      value?.[CREATED_VARIANT_FIELDS.IMAGES] &&
      value?.[CREATED_VARIANT_FIELDS.MINIMUM_ORDER_QUANTITY] &&
      value?.[CREATED_VARIANT_FIELDS.WEIGHT] &&
      value?.[CREATED_VARIANT_FIELDS.SALE_PRICE] &&
      isQtyTypeNumber &&
      value?.[CREATED_VARIANT_FIELDS.STOCK_QUANTITY] >= 0
    );
  });
};

export const ATTR_ACTIONS = {
  ATTR_ADDED: "added",
  ATTR_DELETED: "deleted",
  ATTR_OPTIONS_UPDATED: "updated",
  ATTR_DRAG: "dragged",
};

const EMPTY_VARIANT_OBJECT = {
  [CREATED_VARIANT_FIELDS.WEIGHT]: null,
  [CREATED_VARIANT_FIELDS.MINIMUM_ORDER_QUANTITY]: null,
  [CREATED_VARIANT_FIELDS.SALE_PRICE]: null,
  [CREATED_VARIANT_FIELDS.STOCK_QUANTITY]: null,
  [CREATED_VARIANT_FIELDS.IMAGES]: null,
};

export const showUpdatedVariant = (
  attributeArray = [],
  currentVariants = []
) => {
  const arr = attributeArray
    .filter((arr) => arr.keyId)
    .reduce(
      (acc = [], curr = []) => {
        return acc.flatMap((value) => {
          return curr.attrOptions.map((attr) => {
            return {
              [CREATED_VARIANT_FIELDS.ATTRIBUTES]: {
                ...value?.attributes,
                [curr?.keyId]: {
                  value: attr.value,
                  label: attr.label,
                },
              },
            };
          });
        });
      },
      [""]
    );

  const MAP_VARS_TO_OBJ = validateVariants(currentVariants)?.reduce(
    (prev, curr) => {
      const varName = getVariantName(curr?.attributes);
      if (!prev[varName]) {
        prev[varName] = curr;
      }
      return prev;
    },
    {}
  );
  const AttrFinArr = arr.filter((arr) => arr);
  return AttrFinArr.map((combined, ind) => {
    const updName = getVariantName(combined.attributes);
    if (MAP_VARS_TO_OBJ[updName]) {
      const getObjforVarName = MAP_VARS_TO_OBJ[updName] || {};
      return {
        ...EMPTY_VARIANT_OBJECT,
        ...getObjforVarName,
        ...combined,
      };
    } else return null;
  }).filter((val) => val);
};
export const createCheckName = (attributes = {}) => {
  return `${attributes?.["Size"]?.value || ""} / ${attributes?.["Color"]?.value || ""
    } / ${attributes?.["Material"]?.value || ""}`;
};

export const combineVariants = (
  attributeArray = [],
  currentVariants = [],
  attrAction = {
    action: null,
    index: null,
  }
) => {
  try {
    const arr = attributeArray
      .filter((arr) => arr.keyId)
      .reduce(
        (acc = [], curr = []) => {
          return acc.flatMap((value) => {
            return curr.attrOptions.map((attr) => {
              return {
                [CREATED_VARIANT_FIELDS.ATTRIBUTES]: {
                  ...value?.attributes,
                  [curr?.keyId]: {
                    value: attr.value,
                    label: attr.label,
                  },
                },
              };
            });
          });
        },
        [""]
      );

    const MAP_VARS_TO_OBJ = currentVariants?.reduce((prev, curr) => {
      const varName = getVariantName(curr?.attributes);
      if (!prev[varName]) {
        prev[varName] = curr;
      }
      return prev;
    }, {});
    // ! CAN MAP Current variants to ensure data is there after updaing
    const AttrFinArr = arr.filter((arr) => arr);
    if (attrAction.action === ATTR_ACTIONS.ATTR_OPTIONS_UPDATED) {
      return AttrFinArr.map((combined, ind) => {
        const updName = getVariantName(combined.attributes);
        const getObjforVarName = MAP_VARS_TO_OBJ[updName] || {};
        return {
          ...EMPTY_VARIANT_OBJECT,
          ...getObjforVarName,
          ...combined,
        };
      });
    } else if (attrAction.action === ATTR_ACTIONS.ATTR_ADDED) {
      const firstOpt = attributeArray[attrAction.index].attrOptions[0]?.value;
      let iter = 0;
      let sameInd = false;
      if (AttrFinArr.length === currentVariants.length) {
        sameInd = true;
      }
      return AttrFinArr.map((combined, ind) => {
        const updName = getVariantName(combined.attributes);
        let getObjforVarName = {};
        if (sameInd) {
          getObjforVarName = currentVariants[ind];
        } else if (updName.includes(firstOpt)) {
          getObjforVarName = currentVariants[iter];
          iter++;
        }
        return {
          ...EMPTY_VARIANT_OBJECT,
          ...getObjforVarName,
          ...combined,
        };
      });
    } else if (attrAction.action === ATTR_ACTIONS.ATTR_DELETED) {
      let sameInd = false;
      let indFact = currentVariants.length / AttrFinArr.length;
      if (AttrFinArr.length === currentVariants.length) {
        sameInd = true;
      }
      const vars = currentVariants
        .map((val, ind) => {
          if (ind % indFact === 0 || sameInd) {
            return {
              ...val,
              attributes: AttrFinArr[ind / indFact].attributes,
            };
          } else {
            return null;
          }
        })
        .filter((val) => Boolean(val));
      return vars;
    } else if (attrAction.action === ATTR_ACTIONS.ATTR_DRAG) {
      const MAP_ATTR_TO_NAME = currentVariants?.reduce((prev, curr) => {
        const varName = createCheckName(curr.attributes);
        if (!prev[varName]) {
          prev[varName] = curr;
        }
        return prev;
      }, {});
      return AttrFinArr.map((combined, ind) => {
        const updName = createCheckName(combined.attributes);
        const getObjforVarName = MAP_ATTR_TO_NAME[updName] || {};
        return {
          ...EMPTY_VARIANT_OBJECT,
          ...getObjforVarName,
          ...combined,
        };
      });
    } else if (attrAction.action === null) {
      return AttrFinArr.map((combined, ind) => ({
        ...combined,
        ...EMPTY_VARIANT_OBJECT,
        ...currentVariants?.[ind],
      }));
    }
    return AttrFinArr.map((combined, ind) => ({
      ...combined,
      ...EMPTY_VARIANT_OBJECT,
    }));
  } catch (error) {
    return [];
  }
};

export const mapAttributeObjectToList = (attributes = {}) => {
  return Object.keys(attributes || {}).map((key) => ({
    keyId: key,
    attrOptions: attributes?.[key]?.map((opt) => ({
      ...opt,
      label: opt?.meta?.hexcode || null,
    })),
  }));
};

export const mapLabelToAttributes = (variants = []) => {
  return variants?.map((vari) => {
    if (vari.attributes) {
      for (let key in vari.attributes) {
        if (vari?.attributes?.hasOwnProperty?.(key)) {
          if (key.toLowerCase() === "Color".toLowerCase()) {
            vari.attributes[key]["label"] =
              vari?.attributes?.[key]?.["meta"]?.hexcode;
          } else {
            vari.attributes[key]["label"] = vari?.attributes?.[key]?.["meta"];
          }
        }
      }
    }
    return vari;
  });
};

export const transformVariantImages = (variants = []) => {
  return variants?.map((vari, vInd) => {
    let tenp_imgs = null;
    if (vari?.images?.length) {
      tenp_imgs = vari?.images?.map((img, ind) => {
        return {
          ...img,
          image: img?.image_url,
          imageLibIndex: vInd,
        };
      });
    }
    return { ...vari, images: tenp_imgs, variant_id: vari.id || null };
  });
};

export const handleSwapOnDrag = () => { };

export const handleIntegerInput = (e) => {
  const inputsToBlock = ["."];
  if (inputsToBlock.includes(e.key)) {
    e.preventDefault();
  }
};

export const checkDraginLimit = (clX = 0, clY = 0, elemID = "") => {
  const doc = document.getElementById(elemID);
  if (doc) {
    const { x, width, y, height } = doc?.getClientRects()?.[0];
    let left_limit = x;
    let right_limit = x + width;
    let top_limit = y;
    let bottom_limit = y + height;
    if (
      clX < left_limit ||
      clX > right_limit ||
      clY < top_limit ||
      clY > bottom_limit
    ) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};

export const checkDeletedAttributeOptions = (
  currentOpts = [],
  newOpts = []
) => {
  const newOptObject = {};
  newOpts.forEach((opts) => {
    newOptObject[opts?.value] = true;
  });
  return currentOpts.filter((opts) => !Boolean(newOptObject[opts?.value]));
  // if(opt)
};

export const getAllAttributeIds = (attributes = {}) => {
  let attributeIds = [];
  for (const key in attributes) {
    if (attributes.hasOwnProperty(key)) {
      attributeIds = [...attributeIds, ...attributes[key]];
    }
  }
  return attributeIds.map((value) => value?.id).filter((attr) => attr);
};
